import type { FC } from 'react';

import type { MetadataValues } from '@iconik-io/iconik-api/src/schema_patched/metadata';
import { OBJECT_TYPE_SEGMENTS } from '@iconik-io/iconik-api/src/types/object_types';
import type { SegmentEntityWithIdNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/segment';
import { elasticToForm } from '@iconik-io/shared-lib/src/utils/metadata_elastic_to_form';

import Form from '../../ui/forms/form';
import EntityMetadata from '../entity_metadata/entity_metadata';

const prefix = 'metadata.';

type Props = {
  segment: SegmentEntityWithIdNormalized;
  value: MetadataValues;
};

export const SegmentValueGeneric: FC<Props> = (props) => (
  <Form vertical>
    <EntityMetadata
      disabled
      visibleMetadata
      loading={false}
      componentClass="div"
      objectType={OBJECT_TYPE_SEGMENTS}
      categoryName="generic"
      showViewsSelector={false}
      showCategoriesSelector={false}
      metadataValues={elasticToForm(props.value, prefix)}
      viewId={props.segment.metadata_view_id ?? undefined}
      prefix={prefix}
    />
  </Form>
);
